import type { OpportunityCategoryColumn } from "@api/opportunity";

export type ColumnDef = {
  field: string;
  header: string;
  width: string;
  isDate?: boolean;
  isInt?: boolean;
  isPrimarySort?: boolean;
  openEdit?: boolean;
};

export function apiColumnsToColumnDefs(columns: OpportunityCategoryColumn[]): ColumnDef[] {
  const sorted = [...columns].sort((a, b) => a.sort_order - b.sort_order);
  const count = sorted.length;
  return sorted.map((col) => ({
    field: col.field_key,
    header: col.header,
    width: `${Math.floor(96 / count)}%`,
    isDate: col.field_type === "date",
    isInt: col.field_type === "int",
    isPrimarySort: col.is_primary_sort_field,
    openEdit: col.open_edit,
  }));
}
